<template>
  <tooltip class="tooltip-wrapper right-auto">
    <template #toggle>
      <sup><icon icon="info" /></sup>
    </template>
    <div class="variable-rate-tooltip-text">
      <p>Variable Rates</p>
      <p>
        Current offered rate is calculated using the Index, Margin and Floor value(s) in effect.
        Your specific Interest Rate, Margin, Floor, and/or credit approval depends upon the credit
        qualifications of the student borrower and
        {{ coApplicantTypeDisplayName }} (if applicable).
      </p>
      <p>
        The "Index" for the quarter beginning
        {{ startOfQuarter }} is {{ indexRate }}, which was the Prime index published in the Wall
        Street Journal on the first business day of {{ indexPublishDate }}. The credit approved
        margin is {{ margin }}. Floor and Ceiling will be disclosed at account opening.
      </p>
    </div>
  </tooltip>
</template>

<script setup lang="ts">
import { defineProps, PropType, computed } from "vue";
import usePaymentOptions from "@/use/paymentOptions";
import Tooltip from "@/components/pel-loan-configuration/Tooltip.vue";
import Icon from "@/components/shared/Icon.vue";
import { RatePlanVM } from "@/models/loanConfiguration";
import { useStore } from "vuex";

const store = useStore();

const { formatRatePercentages, formatStartOfQuarter } = usePaymentOptions();

const props = defineProps({
  option: {
    type: Object as PropType<RatePlanVM>,
  },
});

const coApplicantTypeDisplayName = computed<string>(() =>
  store.getters["coApplicantTypeDisplayName"]?.toLowerCase(),
);

const startOfQuarter = computed<string>(() => formatStartOfQuarter(props.option?.startOfQuarter));

const indexRate = computed(() =>
  props.option?.indexRate
    ? formatRatePercentages(props.option?.indexRate, 3)
    : props.option?.indexRate,
);

const margin = computed(() =>
  props.option?.margin ? formatRatePercentages(props.option?.margin, 3) : props.option?.margin,
);

const indexPublishDate = computed(() => props.option?.indexPublishDate);
</script>
<style scoped>
.tooltip-wrapper .variable-rate-tooltip-text p {
  color: #000;
  font-family: var(--header-font);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: var(--font-weight-normal);
  line-height: 15px; /* 125% */
  margin-bottom: 0;
}

.tooltip-wrapper .variable-rate-tooltip-text :first-child {
  font-weight: var(--font-weight-bold);
  margin-bottom: 0px;
  line-height: 21px; /* 175% */
}
:not(.tooltip-wrapper .variable-rate-tooltip-text p:first-child) {
  margin-bottom: 0.5rem;
}
.variable-rate-tooltip .icon {
  height: 16px;
  width: 16px;
  color: #000;
  flex-shrink: 0;
}
.icon {
  fill: #000;
  height: 12px;
  width: 12px;
  color: #000;
  z-index: 3;
}

@media (max-width: 576.98px) {
  sup {
    top: 0;
    font-size: 100%;
  }
}
</style>
